export const routes = (parentName) => {
  return [
    {
      path: "assist",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Assist`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "",
          name: `${parentName}-Assist-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "list-special",
          name: `${parentName}-Assist-List-Special`,
          component: () => import("./ListSpecial.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "list-deposit",
          name: `${parentName}-Assist-List-Deposit`,
          component: () => import("./ListDeposit.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "list-lunch",
          name: `${parentName}-Assist-List-Lunch`,
          component: () => import("./ListLunch.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Assist-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Assist-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Assist-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
